import {h} from 'preact';
import {createPortal} from 'preact/compat';
import {Switch, Tooltip} from "antd";
import designService from "../service/designService";
import store from "../store";
import * as actions from "../actions";
import { CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import "antd/lib/tooltip/style/index.css";
import constants from '../constants';

export function DataSettingsModal({designId, open, onModalClose, dsaAutoSyncEnabled, posAutoSyncEnabled}) {

  function toggleDSASync() {
    const value = !dsaAutoSyncEnabled;
    store.dispatch(actions.setDsaAutoSyncEnabled(value));
    if (value) {
      store.dispatch(actions.setPosAutoSyncEnabled(value));
    }
    designService.toggleDSAAutoSync(designId);
  }

  function togglePOSSync() {
    const value = !posAutoSyncEnabled;
    designService.togglePOSAutoSync(designId);
    store.dispatch(actions.setPosAutoSyncEnabled(value));

    if (!value && dsaAutoSyncEnabled) {
      toggleDSASync()
    }
  }

  return open ? createPortal(<div>
    <div className="modal-back" onClick={onModalClose}/>
    <div className="modal data-settings-modal">
      <header>
        <CloseOutlined onClick={onModalClose}/>
        <h2>Data Settings</h2>
      </header>
      <section>
        <div className="switch-title">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/DSATeal.svg" alt="dsa"/>
          <h3>Display Refresh</h3>
          <Tooltip 
            title="Refreshes the content on screens whenever imported (POS) menu items for that location change." 
            placement="bottomLeft"
            showArrow={false}
            mouseLeaveDelay={0}
            overlayInnerStyle={{backgroundColor: "#E6F7FF", border: "1px solid #91D5FF", borderRadius: "2px", color: "#333"}}
          >
            <QuestionCircleOutlined/>
          </Tooltip>
        </div>
        <div>
          <span>Auto</span>
          <Switch checked={!dsaAutoSyncEnabled} disabled={!posAutoSyncEnabled} onChange={toggleDSASync}/>
          <span>Manual</span>
        </div>
      </section>

      <section>
        <div className="switch-title">
          <h3>Menu Data Update</h3>
          <Tooltip 
              title="Automatically updates in-use menu items whenever changes are made in the POS for that location." 
              placement="bottomLeft"
              showArrow={false}
              mouseLeaveDelay={0}
              overlayInnerStyle={{backgroundColor: "#E6F7FF", border: "1px solid #91D5FF", borderRadius: "2px", color: "#333"}}
            >
            <QuestionCircleOutlined/>
          </Tooltip>
        </div>
        <div>
          <span>Auto</span>
          <Switch checked={!posAutoSyncEnabled} onChange={togglePOSSync}/>
          <span>Manual</span>
        </div>
      </section>
    </div>
  </div>, document.getElementById('modals')) : null;
}
